<template>
  <v-dialog
    v-model="visible"
    max-width="480"
    @input="$emit('dialog-shown', show)"
  >
    <v-alert 
      border="top"
      colored-border
      prominent
      v-if="!agree"
      type="error">
      <p>
        You are about to upload a recording to <strong class="primary--text">Ceol</strong>.
      </p>
      <p>
        <strong>Users are responsible </strong>for the content they upload.
      </p>
      <p>
        By uploading, <strong>you agree not to submit</strong> content that:
        <ul>
          <li>
            Contains hate speech, discrimination, or offensive material.
          </li>
          <li>
            Violates copyright or other intellectual property rights.
          </li>
          <li>
            Promotes violence, illegal activities, or harmful behavior.
          </li>
          <li>
            Includes adult, explicit, or inappropriate content.
          </li>
          <li>
            Spreads false, misleading, or malicious information.
          </li>
        </ul>
      </p>
      <v-checkbox
        label="I agree to the above terms"
        v-model="agree">
      </v-checkbox>
      <v-row>
        <v-col cols="12" id="">
          <!-- <v-btn id="startCtx" color="info" @click="tutoInfo = false;" block>Got it!</v-btn> -->
        </v-col>
      </v-row>
    </v-alert>
    <v-card v-else>
      <v-card-title>Upload recording</v-card-title>
      <v-card-text>
        <v-file-input
          accept="audio/*"
          label="Upload recording"
          @change="handleFile"
        ></v-file-input>
        <div ref="surf-wrap"></div>
        <v-btn v-if="file" block color="primary" @click="uploadFile">
          <v-icon>mdi-upload</v-icon>Upload recording
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
 import * as Tone from "tone";
import WaveSurfer from 'wavesurfer.js'
export default {

  name: 'RecordingUpload',
  components: {
  },
  props: ['tuneid'],
  data: function () {
    return {
      visible: false,
      agree: false,
      surfer: null,
      file: null,
    }
  },
  mounted() {
    if (!this.ctx) {
      document.getElementById('startCtx').addEventListener('click', async () => {
        await Tone.start()
        this.ctx = Tone.getContext()
      })
    }
  },
  methods: {
    initWavesurfer(audio) {

      this.surfer = WaveSurfer.create({
        container: this.$refs['surf-wrap'],
        waveColor: 'rgba(0, 154, 68,0.5)',
        progressColor: 'rgba(0, 154, 68,0.5)',
        dragToSeek: true,
        mediaControls: true,
        cursorColor: 'rgba(255,136,62)',
        cursorWidth: 2,
        media: audio,
      });
      this.surfer.on('click', () => {
        this.surfer.play()
      })  
    },
    uploadFile() {
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("title", this.file.name);
      formData.append("recording_type", "user_upload");
      formData.append("instruments", JSON.stringify({}));
      formData.append("src", "N/A");
      formData.append("tunes", [this.tuneid]);
      this.$store.dispatch('tune/addRecording', formData);
    },
    show() {
      return this.visible = true;
    },
    hide() {
      return this.visible = false;
    },
    handleFile(file) {
      this.file = file;
      if (this.surfer) {
        this.surfer.destroy();
        this.surfer = null;
      }
      if (file) {
        var vm = this;
        var fr = new FileReader();
        fr.readAsDataURL(file);
        fr.onload = (e) => {
            var audio = new Audio()
            audio.src = e.target.result
            vm.initWavesurfer(audio);
        };
      }
    }
  },
  computed: {
    ctx: {
      get() {
        return this.$store.state.tune.ctx;
      },
      set(val) {
        return this.$store.commit('tune/setCtx', val)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
